
// Google Analytics configuration
// This uses Google Analytics 4 (gtag.js) implementation

// GA4 Measurement ID - replace with your actual GA4 ID in production
const GA_MEASUREMENT_ID = 'G-BDGB0L7QTT'; 

// Define window.gtag for TypeScript
declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

// Initialize Google Analytics
export const initializeGA = () => {
  // Check if GA script is already loaded
  if (document.querySelector(`script[src*="googletagmanager.com/gtag/js"]`)) {
    return;
  }
  
  // Create script elements for Google Analytics
  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  
  const script2 = document.createElement('script');
  script2.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${GA_MEASUREMENT_ID}');
  `;
  
  // Add scripts to document
  document.head.appendChild(script1);
  document.head.appendChild(script2);
  
  console.log('Google Analytics initialized');
};

// Track page views
export const trackPageView = (path: string) => {
  if (window.gtag && typeof window.gtag === 'function') {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: path
    });
    console.log(`Page view tracked: ${path}`);
  }
};

// Disable Google Analytics
export const disableGA = () => {
  // Create or update GA disable cookies
  document.cookie = `ga-disable-${GA_MEASUREMENT_ID}=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/`;
  
  // No need to check for window.gaOptout as it's not a standard property
  console.log('Google Analytics disabled');
};

// Remove Google Analytics
export const removeGA = () => {
  // Remove GA scripts from the page
  const scripts = document.querySelectorAll('script[src*="googletagmanager.com/gtag/js"]');
  scripts.forEach(script => script.remove());
  
  // Remove inline script
  const inlineScripts = document.querySelectorAll('script');
  inlineScripts.forEach(script => {
    if (script.innerHTML.includes('gtag') && script.innerHTML.includes(GA_MEASUREMENT_ID)) {
      script.remove();
    }
  });
  
  console.log('Google Analytics removed');
};

// Check if Google Analytics is enabled based on cookie consent
export const checkAndInitGA = () => {
  const cookieConsent = localStorage.getItem('cookieConsent');
  
  if (cookieConsent === 'accepted') {
    initializeGA();
  } else if (cookieConsent === 'rejected') {
    disableGA();
  }
};
